<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Devices</v-toolbar-title>
        </v-toolbar>
      </v-flex>

      <v-flex md12>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" @click.prevent="callNewDevice()" v-if="aaaaccess(user)">
              <v-icon dark left>create</v-icon>
              New Device
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :footer-props="{
              'items-per-page-options': [15, 50, -1]
            }"
            :items="Object.values(allDevices)"
            :loading="isLoading.devices"
            :search="search"
            :sort-by="'model'"
            :sort-desc="false"
            item-key="deviceid"
            class="elevation-1"
            dense
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.deviceid" @click="openDeviceTab(item)" :style="{cursor:'pointer'}">
                  <td><v-icon small>reorder</v-icon></td>
                  <td>{{ smallId(item.deviceid) }}</td>
                  <td>{{ deviceTypeToString(item.type) }}</td>
                  <td>{{ item.model }}</td>
                  <td>{{ item.templateid }}</td>
                  <td>{{ item.owner }}</td>
                  <td>{{ dateToString(item.lastmodified) }}</td>
                  <td >
                    <v-icon small v-if="item.approved">check</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
  mixins: [libvue],
  data () {
    return {
      search: null,
      dialog: false,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      headers: [
        { text: '', value: '' },
        { text: 'ID', value: 'templateid' },
        { text: 'Type', value: 'type' },
        { text: 'Model', value: 'model' },
        { text: 'Template', value: 'templateid' },
        { text: 'Owner', value: 'owner' },
        { text: 'Last Modified', value: 'lastmodified' },
        { text: 'Approved', sortable: true, value: 'approved' }
      ]
    }
  },
  computed: {
    ...mapGetters(['allDevices', 'user', 'isLoading', 'error']),
  },
  created() {
    this.filterDevices();
  },
  watch: {
  },
  methods: {
    callNewDevice() {
      this.dialog = true;
      this.newDevice().then((v) => {
        this.dialog = false;
        this.snack = false;
        this.openDeviceTab(v);
      }).catch((err) => {
        this.dialog = false;
        this.snack = true;
        this.snackColor = 'error'
        this.snackMessage = this.errToString(err);
      });
    },
    openDeviceTab(v) {
      this.$router.push({ name: 'device-details', params: { DeviceID: v.deviceid } });
    },
    ...mapActions(['filterDevices', 'newDevice'])
  }
}
</script>
